import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SvgSprite from './components/SvgSprite';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import './styles/core.css';
import './styles/home.css';
import './styles/product.css';
import './styles/contact.css';
import './styles/mobile.css';

/**
 * 공개 사이트(홈 / 제품소개 / 문의하기) 공통 레이아웃
 *
 * - 모든 사이트 CSS 는 .acx-site 아래로 스코프되어 있어서 앱(AppShell 등) 스타일과 섞이지 않음
 * - 루트의 js / pdjs / prjs 클래스는 등장(reveal) 애니메이션 CSS 의 스위치
 *   (원본에서는 <html> 에 붙던 클래스. 스크립트가 있을 때만 요소를 숨겼다가 보여주기 위함)
 */
export default function SiteLayout() {
  const { pathname, hash } = useLocation();

  // 페이지 이동 시 맨 위로 (앵커 이동은 각 페이지가 처리)
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);

  // 스크롤하면 헤더 하단 선 표시
  useEffect(() => {
    const header = document.querySelector('.acx-site .gnb');
    const onScroll = () => header?.classList.toggle('sh', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="acx-site js pdjs prjs">
      <SvgSprite />
      <SiteHeader />
      <Outlet />
      <SiteFooter />
    </div>
  );
}
